module.exports = __webpack_public_path__ + "static/media/BIM 360.29793729.png";